import DataItem from 'components/DataItem';

export default function CruiseCabin({ cabin }) {
  const { 
    name,
    displayType,
    bedConfiguration,
    prePaidGratuity,
    grade,
    sitting,
    tableSize,
  } = cabin;

  return (
    <div className="bg-white">
      <div className="flex flex-wrap bg-white">
        <DataItem label="Cabin Name/Number" value={name} />
        <DataItem label="Cabin Type" value={displayType} />
        <DataItem label="Cabin Grade" value={grade} />
        <DataItem label="Bed Configuration" value={bedConfiguration} />
        <DataItem label="Sitting" value={sitting} />
        <DataItem label="Table Size" value={tableSize} />
        <DataItem label="Pre-Paid Gratuity" value={prePaidGratuity} />
      </div>
    </div>
  );
}
